import type {
  APIRequestBody,
  APIRequestPathParams,
  APIResponse,
} from './base-fetch';
import { get, post } from './base-fetch';

export type RequestProjectData = APIRequestBody<'/api/v4/request-project'>;

export type RequestProjectResponse = APIResponse<'/api/v4/request-project'>;

export type ApproveProjectRequestResponse =
  APIResponse<'/api/v4/request-project/{requestId}/approve'>;

export const requestProject = async (
  data: RequestProjectData,
): Promise<RequestProjectResponse> => {
  return post<RequestProjectResponse, RequestProjectData>(
    'v4/request-project',
    data,
  );
};

export const approveProjectRequest = async (
  requestId: string,
): Promise<ApproveProjectRequestResponse> => {
  return post<ApproveProjectRequestResponse, void>(
    `v4/request-project/${requestId}/approve`,
  );
};

export const rejectProjectRequest = async (
  requestId: string,
): Promise<void> => {
  return post<void, void>(`v4/request-project/${requestId}/reject`);
};

export const fetchPendingProjectRequests = async (params: {
  page?: number;
  items?: number;
}) => {
  const queryParams = new URLSearchParams();
  if (params.page) queryParams.append('page', params.page.toString());
  if (params.items) queryParams.append('items', params.items.toString());

  const queryString = queryParams.toString();
  const url = queryString
    ? `v4/request-project?${queryString}`
    : 'v4/request-project';

  return get<RequestProjectResponse[]>(url);
};

export const fetchPendingProjectRequestsCount = async () => {
  return get<{ count: number }>('v4/request-project/count');
};

export type ValidateRequestProjectSubmissionLinkParams =
  APIRequestPathParams<'/api/v4/request-project/validate-link/{linkId}'>;

export type ValidateRequestProjectSubmissionLinkResponse =
  APIResponse<'/api/v4/request-project/validate-link/{linkId}'>;

export const validateRequestProjectSubmissionLink = async ({
  linkId,
}: ValidateRequestProjectSubmissionLinkParams): Promise<ValidateRequestProjectSubmissionLinkResponse> => {
  return get<ValidateRequestProjectSubmissionLinkResponse>(
    `v4/request-project/validate-link/${linkId}`,
  );
};
